import React, {Component} from 'react';
import PropTypes from 'prop-types';

const LOCALES = {
    "top-link": {
        title: {
            fr: "Revenir en haut de la page",
            en: "Return to the top of the page"
        }
    }
};

class TopLink extends Component {
    constructor(props) {
        super(props);
        
        this._onClickHandler = this._onClickHandler.bind(this);
        this._onScrollHandler = this._onScrollHandler.bind(this);
    }

    componentDidMount() {
        window.$(this.props.parent).on('scroll',this._onScrollHandler);
    }

    componentWillUnmount() {
        window.$(this.props.parent).off('scroll');
    }

    render() {
        return <a role="button" className="top_link" ref={(el) => this.topLink = el} onClick={this._onClickHandler} title={LOCALES["top-link"]["title"][this.props.lang]}><span className="glyphicon glyphicon-chevron-up" /></a>
    }

    _onClickHandler(e) {
        window.$(this.props.parent).scrollTop(0);
    }
    
    _onScrollHandler(e) {
        let posScroll = window.$(this.props.parent).scrollTop();
    
        if(posScroll >= this.props.threshold)
        {
            window.$(this.topLink).fadeIn(600);
        } 
        else
        {
            window.$(this.topLink).fadeOut(600);
        }
    }
}

TopLink.defaultProps = {
    parent: document,
    threshold: 150
};

TopLink.propTypes = {
    lang: PropTypes.string.isRequired,
    parent: PropTypes.any,
    threshold: PropTypes.number
};

export default TopLink;